// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__325dg","type":"styles_type__1hLil","choices":"styles_choices__11xI1"};